// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckoutPage{margin:20px 0;min-height:800px}`, "",{"version":3,"sources":["webpack://./source/routes/CheckoutPage.scss"],"names":[],"mappings":"AAAA,cACC,aAAA,CACA,gBAAA","sourcesContent":[".CheckoutPage {\n\tmargin: 20px 0;\n\tmin-height: 800px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
